import { apiProxyRequest } from "Api/apiProxyRequest";

import type {
  RunEnvironmentTaskRequestProps,
  RunEnvironmentTaskResponse
} from "./types";

/**
 * Triggers a task run. Posts to the task's `#run` href with the optional
 * per-task `variables` body (defaults to `{}`). Creates an `environment.task`
 * activity, returned under `_embedded.activities[0]`.
 */
export const runEnvironmentTaskRequest = ({
  runHref,
  variables
}: RunEnvironmentTaskRequestProps) =>
  apiProxyRequest<RunEnvironmentTaskResponse>(runHref, "POST", variables ?? {});
